export default function WhyDiivy() {
  return (
    <section className="py-36 bg-[#F7F4EF]">
      <div className="max-w-[1280px] mx-auto px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          {/* Left: Label */}
          <div className="lg:col-span-3">
            <div className="flex items-center gap-4 mb-6">
              <span className="block w-10 h-[1px] bg-[#C9A96E]"></span>
              <p className="text-[11px] font-semibold tracking-[0.24em] uppercase text-[#C9A96E]">
                Why Diivy
              </p>
            </div>
          </div>

          {/* Right: Content */}
          <div className="lg:col-span-9 space-y-12">
            <h2 className="text-[44px] lg:text-[52px] font-light text-[#0A0F1E] leading-[1.15] tracking-[-0.02em]">
              Built for clarity, focus, and <span className="font-semibold">long-term value</span>
            </h2>

            <div className="space-y-8 max-w-[720px]">
              <p className="text-[17px] text-gray-600 leading-[1.8] font-light">
                Diivy exists to build and support companies where thoughtful strategy and strong execution can create lasting impact. We believe the strongest businesses are not built by chasing noise, but by solving real problems with discipline and conviction.
              </p>

              <p className="text-[17px] text-gray-600 leading-[1.8] font-light">
                Our portfolio is intentionally focused. That focus allows us to support each company with greater depth, stronger alignment, and a clearer path to long-term growth.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}